import React from "react";

export interface AtmosphericParticlesProps {
  frame: number;
  count?: number;
}

export const AtmosphericParticles: React.FC<AtmosphericParticlesProps> = ({
  frame,
  count = 18,
}) => {
  const particles = Array.from({ length: count }).map((_, i) => {
    const seedX = ((i * 137.5) % 900) - 450;
    const startY = 850 + (i * 65);
    const speed = 1.6 + ((i * 3.7) % 2.2);
    const currentY = startY - ((frame * speed * 3.2) % 1700);
    const size = 3 + (i % 5);
    const zDepth = -60 + ((i * 47) % 220); // Multi-depth z-axis
    const blur = zDepth > 100 ? 1.5 : zDepth < 0 ? 3.5 : 0.8;
    const opacity = 0.25 + (((i * 7) % 10) / 10) * 0.55;
    const color = i % 3 === 0 ? "#FFB020" : i % 3 === 1 ? "#5D3FD3" : "#00F0FF";
    return { id: i, x: seedX, y: currentY, size, zDepth, blur, opacity, color };
  });

  return (
    <>
      {particles.map((p) => (
        <div
          key={p.id}
          style={{
            position: "absolute",
            left: `calc(50% + ${p.x}px)`,
            top: p.y,
            width: p.size,
            height: p.size,
            borderRadius: "50%",
            backgroundColor: p.color,
            boxShadow: `0 0 ${p.size * 3}px ${p.color}`,
            filter: `blur(${p.blur}px)`,
            opacity: p.opacity,
            transform: `translateZ(${p.zDepth}px)`,
            pointerEvents: "none",
            zIndex: 45,
          }}
        />
      ))}
    </>
  );
};
